<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-main>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="white pa-3 app--footer">
              <span class="caption">nghienorder.com Design &copy; 2022</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-main>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-snackbar :timeout="snackbar.timeout ? snackbar.timeout : 30000" :color="snackbar.color" v-model="snackbar.show" top multi-line>
            <p class="mt-4 body-1">{{ snackbar.text }}<v-btn class="pl-4" dark text @click.native="snackbar.show = false" icon>
              <v-icon>close</v-icon>
            </v-btn></p>
          </v-snackbar>
          <v-dialog v-model="delDialog" persistent max-width="320">
            <v-card>
              <v-card-title class="subheading">Xác nhận</v-card-title>
              <v-card-text>{{ delMessage || 'Bạn có chắc chắn muốn xóa mục đã chọn?'}}</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="green darken-1" text @click="delConfirmed">Đồng ý</v-btn>
                <v-btn color="green darken-1" text @click="delDialog = false">Hủy</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    delMessage: "",
    delDialog: false,
    delId: 0,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  computed: {
    ...mapState("commons", {
      sidebarExpanded: "sidebarExpanded"
    })
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.$store.commit("commons/setSidebarExpanded", {
        expanded: !this.sidebarExpanded
      });
    });
  },
  mounted() {
    if(this.$store.state.authentication.token != "") {
      this.$store.dispatch("roles/getList");
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 230px;
}

.v-snack__wrapper p {
  margin: 0 0 0 0 !important;
}
</style>
